'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var classList = this.compileStyle(_index2.default),
        additionalClass = '',
        content = this.props.children;

    if (this.props.type === 'field') {
        additionalClass = this.props.name ? this.props.name + '-error' : '';
    }

    if (this.props.type === 'form') {
        content = _react2.default.createElement(
            'div',
            { className: classList.formContent },
            _react2.default.createElement('div', { className: classList.formIcon }),
            _react2.default.createElement(
                'div',
                null,
                content
            )
        );
    }

    return _react2.default.createElement(
        'div',
        {
            className: classList.root + ' ' + additionalClass + ' ' + (this.props.className || ''),
            ref: this._createRef.bind(this)
        },
        content
    );
}